import React, { FC, SyntheticEvent, useMemo, useEffect } from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import { TaxesByDateRes } from '../../../../services/order.service.ts';
import { TableSelect } from '../../../../../../shared/components/table/styles/styleFields.ts';
import { ISelectOption } from '../../../../../../shared/components/form/fields/select.component.tsx';
import { orderDetailsState as orderDetailsStateCreate } from '../../../../create/states/orderDetails/orderDetails.state.ts';
import { orderDetailsState as orderDetailsStateEdit } from '../../../../edit/states/orderDetails/orderDetails.state.ts';

export const VatEditCell: FC<IVatEditCell> = ({ params, taxes, type }) => {
  const { api, id, field, row, formattedValue } = params;

  useEffect(() => {
    setEditCellValue({ id, field, value: formattedValue });
  }, []);

  const { setEditCellValue, stopCellEditMode } = api;
  const value = useMemo(() => {
    return taxes?.find((el) => el?.id === formattedValue);
  }, []);
  const handleChange = (_: SyntheticEvent, v: ISelectOption | null) => {
    setEditCellValue({ id, field, value: v?.id });
    (type === 'create' ? orderDetailsStateCreate : orderDetailsStateEdit).pub.updateCell(
      {
        ...row,
        vatCode: v?.id,
      },
      'vatCodeCell',
    );
    stopCellEditMode({ id, field });
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.target instanceof HTMLInputElement) {
      if (e.code === 'Escape') {
        stopCellEditMode({ id, field });
      }
      if (e.code === 'ArrowUp' || e.code === 'ArrowDown') {
        e.stopPropagation();
      }
    }
  };

  return (
    <TableSelect
      autoFocus
      openOnFocus
      size='small'
      width='100%'
      fontSize='14px'
      autoHighlight={true}
      disableClearable
      disableTextInput
      options={taxes as []}
      value={value as ISelectOption}
      inputValue={value?.label || undefined}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
    />
  );
};

interface IVatEditCell {
  params: GridRenderCellParams;
  taxes: TaxesByDateRes;
  type: 'create' | 'edit';
}
